import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export default function CreateCompanyLimitList({ isOpen, setIsOpen }) {
  return (
    <>
      <Button
        className="centered"
        size="medium"
        onClick={() => setIsOpen(true)}
        type="primary"
      >
        <PlusCircleOutlined />
        Create
      </Button>

      {/* <CompanyLimitModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refetch={refetch}
      /> */}
    </>
  );
}
